import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ModernSearch } from 'component-library-next'

import { IModernSearchItem } from '@app/common/helpers/IModernSearchItem'
import {
  IHandleEmailTemplateChange,
  ISelectedEmailTemplate
} from '@app/modules/Messages/Components/AnswerArea/AnswerArea'
import { EmailTemplatePreview } from '@app/modules/Messages/Components/EmailTemplatePreview/EmailTemplatePreview'
import { AnswerButtons } from '@app/modules/Messages/Components/LawyerAnswer/AnswerButtons'
import { customerSalutation } from '@app/modules/Messages/Components/LawyerAnswer/helper/customerSalutation'
import LawyerChatAction from '@app/modules/Messages/store/actions'
import { LawyerChatState } from '@app/modules/Messages/store/models'
import { Message } from '@app/queries/CustomerAsLawyer/models'

import AddDocuments from './AddDocuments'
import ChatDocuments from './AddDocuments/chatDocuments'
import { AddMessage } from './AddMessage'

import './style.scss'

const Documents = ChatDocuments(AddDocuments)

type Props = {
  lastQuestion: Message
  latestMessageId: number
  customer
  requestedLetterNotAdded: boolean
  emailTemplates?: IModernSearchItem[]
  selectedEmailTemplate?: ISelectedEmailTemplate
  setSelectedEmailTemplate?: React.Dispatch<React.SetStateAction<ISelectedEmailTemplate | null>>
  handleEmailTemplateChange?: (props: IHandleEmailTemplateChange) => void
  latestPurchase: string
}

type LawyerChatProps = {
  notes
}

const getLawyerChatState = ({ lawyerChat }: { lawyerChat: LawyerChatState }): LawyerChatProps => ({
  ...lawyerChat
})

export const LawyerAnswer: FC<Props> = (props: Props) => {
  const dispatch = useDispatch()
  const { notes } = useSelector(getLawyerChatState)
  const {
    customer,
    emailTemplates,
    selectedEmailTemplate,
    setSelectedEmailTemplate,
    handleEmailTemplateChange,
    latestPurchase
  } = props

  useEffect(() => {
    if (!notes && customer?.gender) {
      dispatch(LawyerChatAction.addNotes(customerSalutation(customer) + '\n\n'))
    }
  }, [])

  return (
    <div className='lawyer-answer'>
      <AddMessage />

      {latestPurchase !== 'advocard-ai-checks' && (
        <>
          <section className={'lawyer-answer__choose-template'}>
            <h3>Vorlage für Vermieter anschreiben hinzufügen</h3>
            <ModernSearch
              placeholder='Vorlage auswählen'
              noOptionsMessage='Vorlage auswählen'
              groupedOptions={emailTemplates || []}
              onChange={handleEmailTemplateChange}
            />
          </section>

          {selectedEmailTemplate && (
            <EmailTemplatePreview
              emailTemplate={selectedEmailTemplate}
              onClose={() => {
                typeof setSelectedEmailTemplate === 'function' && setSelectedEmailTemplate(null)
              }}
            />
          )}
        </>
      )}

      <Documents {...props} />

      <AnswerButtons {...props} />
    </div>
  )
}
